import React from "react";
import { Route } from "react-router-dom";
import { RequireModuleAccess } from "../../app/session/RequireModuleAccess.js";
import EmailSettingsPage from "./pages/EmailSettingsPage.js";
import AuditLogPage from "./pages/AuditLogPage.js";
import TeamPage from "./pages/TeamPage.js";

export const plataformaRoutes = (
  <Route element={<RequireModuleAccess module="plataforma" />}>
    <Route path="/correo" element={<EmailSettingsPage />} />
    <Route path="/auditoria" element={<AuditLogPage />} />
    <Route path="/equipo" element={<TeamPage />} />
  </Route>
);
